import React from 'react';

interface Props {
  isSubmitting: boolean;
  hasProviderSelected: boolean;
  mode: 'add' | 'edit';
  onCancel: () => void;
  submitError?: string;
}

const FormActions: React.FC<Props> = ({
  isSubmitting,
  hasProviderSelected,
  mode,
  onCancel,
  submitError,
}) => {
  return (
    <>
      {/* Submit Error */}
      {submitError && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <p className="text-red-700 text-sm">{submitError}</p>
        </div>
      )}

      {/* Form Actions */}
      <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200 dark:border-gray-700">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isSubmitting || !hasProviderSelected}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isSubmitting ? (
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
              {mode === 'add' ? 'Adding Provider...' : 'Saving Changes...'}
            </div>
          ) : mode === 'add' ? (
            'Add Provider'
          ) : (
            'Save Changes'
          )}
        </button>
      </div>
    </>
  );
};

export default FormActions;